import {SlideToggle} from "./SlideToggle.tsx";
import {IconLocationPin} from "./svg-icons/IconLocationPin.tsx";
import {IconCalendarFilter} from "./svg-icons/IconCalendarFilter.tsx";
import {Dropdown} from "./Dropdown.tsx";
import {IconFilter} from "./svg-icons/IconFilter.tsx";
import {DropdownOptions, DropdownPayload, SearchFilters} from "../types/travel.ts";

interface GridHeaderProps {
    filters: SearchFilters,
    total: number,
    terminTotal: number,
    gridViewState: boolean,
    setGridViewState: (value: boolean) => void
    onSortChange: (payload : DropdownPayload) => void
    isFilterOverlayOpen?: boolean
    setIsFilterOverlayOpen?: (isOpen: boolean) => void
    currentSortBy?: string
}

export function GridHeader({filters, total, terminTotal, gridViewState, setGridViewState, onSortChange, isFilterOverlayOpen, setIsFilterOverlayOpen, currentSortBy} : GridHeaderProps) {

    const handleChangeFilterOverlayState = () => {
        if(typeof setIsFilterOverlayOpen === 'function') {
            setIsFilterOverlayOpen(!isFilterOverlayOpen)
        }
    }

    const switchSingularPlural = (total: number, type: 'reise' | 'termin'): string => {
        const data = {
            'reise': ['Reise', 'Reisen'],
            'termin': ['Termin', 'Termine']
        }
        return total > 1 ? data[type][1] : data[type][0];
    }

    const filterCount = Object.values(filters)
        .reduce((sum, val) => sum + (Array.isArray(val) ? val.length : 0), 0)

    const mobileSearchFilterButtonText = (filterCount : number) => {
        if (filterCount > 0) {
            return `Filter (${filterCount})`;
        } else {
            if (gridViewState) {
                return `Filtern & Sortieren`
            } else {
                return `Filtern`
            }
        }
    }

    return(
        <>
            <h1 className="mb-6 leading-none">
                    {gridViewState ? `${total} ${switchSingularPlural(total, 'reise')}` : `${terminTotal} ${switchSingularPlural(terminTotal, 'termin')}`}
                 &nbsp;gefunden</h1>
            <div className="mb-7 flex items-center justify-between">
                <SlideToggle
                    gridViewState={gridViewState}
                    setGridViewState={setGridViewState}
                    leftLabel="Reisen"
                    rightLabel="Termine"
                    iconLeft={<IconLocationPin cssClasses="h-5" />}
                    iconRight={<IconCalendarFilter cssClasses="h-5" />}
                    hideTextOnMobile={true}
                    cssClass={'w-full max-w-[120px] sm:max-w-[150px] lg:max-w-full lg:w-auto'}
                />
                {gridViewState && (
                    <Dropdown
                        options={[
                            {value: 'customsort', label: 'Empfehlung'},
                            {value: 'preis', label: 'Niedrigster Preis'},
                            {value: 'anreise', label: 'Frühester Reisebeginn'},
                            {value: 'wertschoepfung', label: 'Höchste Wertschöpfung'},
                        ]}
                        icon={<IconFilter cssClasses="h-4" />}
                        selectText="Bitte Filter wählen"
                        onSelectionChange={(payload:DropdownOptions) => {
                            onSortChange(payload)
                        }}
                        cssClasses="hidden lg:inline-flex"
                        section="sort-desktop"
                        selectedValue={currentSortBy}
                    />
                )}

                <button className="w-full ml-3 block lg:hidden">
                            <span
                                className={
                                    `h-[43px] w-auto px-[14px] py-[14px] rounded-10px
                                        border-2 border-theme-gray-light flex items-center
                                        gap-2 cursor-pointer whitespace-nowrap justify-center`
                                }
                                onClick={() => handleChangeFilterOverlayState()}
                            >
                                <IconFilter cssClasses="h-4" />
                                <span className="text-13px font-semibold leading-none">
                                    {mobileSearchFilterButtonText(filterCount)}
                                </span>
                            </span>
                </button>

            </div>
        </>
    )
}
